<form [formGroup]="properties.formGroup" class="d-flex fd-col gap-8-px">
    <div *ngFor="let controlGroup of properties.formModel" class="d-flex fd-row">
        <div *ngFor="let control of controlGroup" class="d-flex" style="flex: 1;">
            <ng-container *ngIf="control.type === InputType.BUTTON_RADIO; else other">
                <mat-chip-listbox formControlName="{{ control.key }}" multiple>
                    <mat-label *ngIf="control.label" class="text-white main-label">{{ control.label }}</mat-label>
                    <mat-chip-option *ngFor="let option of control.list" [value]="option.value">{{ option.name }}
                    </mat-chip-option>
                </mat-chip-listbox>
            </ng-container>
            <ng-template #other>
                <mat-form-field #other appearance="outline" class="textWhite height-auto">
                    <!-- Label -->
                    <mat-label *ngIf="control.label" class="text-white main-label">{{ control.label }}</mat-label>

                    <ng-container [ngSwitch]="control.type">
                        <mat-select *ngSwitchCase="InputType.SELECT" formControlName="{{ control.key }}">
                            <mat-option *ngFor="let item of control.list" [value]="item.value">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                        <!-- Basic input -->
                        <input *ngSwitchDefault matInput formControlName="{{ control.key }}" />
                    </ng-container>

                    <!-- Error validatiors -->
                    <ng-container *ngIf="control.formControl.validators" ngProjectAs="mat-error">
                        <ng-container *ngFor="let validator of control.formControl.validators;">
                            <mat-error *ngIf="_validateControl(control, validator)">
                                {{ validator.errorMessage }}
                            </mat-error>
                        </ng-container>
                    </ng-container>
                </mat-form-field>
            </ng-template>
        </div>
    </div>
</form>
